// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"Banner_bannerWrapper__6wNJz","loaded":"Banner_loaded__W5iEU"};